export function minutesToHoursAndMinutes(minutes: number) {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return `${minutes >= 60 ? hours.toString() + 'h' : ''} ${
    remainingMinutes > 0 ? remainingMinutes.toString() + 'm' : ''
  }`;
}
